import { Modal } from 'antd'
import css from './index.scss'

const confirm = Modal.confirm

export const showConfirm = (props) => {
  return confirm({
    title: 'Do you Want to delete these items?',
    content: 'Some descriptions',
    onOk() {
    },
    onCancel() {
    },
    ...props,
    bodyStyle: { fontFamily: 'GloberSemiBold' },
    style: { fontFamily: 'GloberSemiBold' },
  })
}

export const showDeleteConfirm = (props) => {
  confirm({
    title: 'Are you sure delete this task?',
    content: 'Some descriptions',
    okText: 'Yes',
    okType: 'danger',
    cancelText: 'No',
    onOk() {
    },
    onCancel() {
    },
    maskClosable: true,
    ...props,
    bodyStyle: { fontFamily: 'GloberSemiBold' },
    style: { fontFamily: 'GloberSemiBold' },
  })
}
